<template>
  <b-modal
    v-model="showModal"
    centered
    ok-variant="primary"
    cancel-variant="bg-white"
    title="Default Project"
    body-class="p-1"
    size="sm"
    :ok-disabled="!selectedId || savingDefaultProject"
    @ok="saveChanges"
  >
    <div
      v-if="projects.length === 0 && fetchingProjects"
      class="text-center py-2"
    >
      <b-spinner />
    </div>
    <div
      v-else
      class="d-flex flex-column align-items-center"
    >
      <div
        v-for="project in projects"
        :key="project.id"
        class="d-flex w-100 align-items-center option"
      >
        <div
          class="d-flex align-items-center"
          @click="project.isDefault ? '' : selectedId = project.id"
        >
          <select-button :selected="selectedId && project.id === selectedId" />
          <span class="option-name">
            {{ project.name }}
          </span>
        </div>
        <span
          v-if="project.isDefault"
          class="text-xsm option-default-text text-secondary"
        >
          (Default)
        </span>
      </div>
      <a
        v-if="hasMore"
        class="d-flex align-items-center option text-sm text-primary cursor-pointer"
        @click="pageIndex = pageIndex + 1"
      >
        Load More
      </a>
    </div>
    <template #modal-ok>
      <div class="d-flex align-items-center">
        <span>
          Save Changes
        </span>
        <b-spinner
          v-if="savingDefaultProject"
          style="margin-left:5px;"
          small
        />
      </div>
    </template>
  </b-modal>
</template>

<script>

import helpers from '@/mixins/helpers'

export default {
  name: 'DefaultProject',
  mixins: [helpers],
  props: {
    value: {
      type: Boolean,
      default: false,
      required: true,
    },
    url: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      savingDefaultProject: false,
      showModal: false,
      pageSize: 5,
      pageIndex: 0,
      projects: [],
      fetchingProjects: false,
      selectedId: null,
      hasMore: false,
    }
  },
  computed: {
    user() { return this.$store.state.users.user },

  },
  watch: {
    value(val) {
      this.showModal = val
      if (val) {
        this.fetchProjects()
      } else {
        this.reset()
      }
    },
    showModal(val) {
      this.$emit('input', val)
    },
    pageIndex() {
      if (this.showModal) {
        this.fetchProjects()
      }
    },
  },
  created() {
    this.showModal = this.value
  },
  methods: {
    reset() {
      this.projects = []
      this.selectedId = null
      this.pageIndex = 0
    },
    saveChanges(e) {
      e.preventDefault()
      this.savingDefaultProject = true
      this.$store.dispatch('users/updateUser', {
        defaultOrganizationId: this.user.defaultOrganizationId,
        defaultProjectId: this.selectedId,
      }).then(() => {
        this.successToast('Default project set successfully')
        this.$emit('defaultSet')
      })
        .catch(error => { this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while setting default project.') })
        .finally(() => {
          this.savingDefaultProject = false
        })
    },
    fetchProjects() {
      this.fetchingProjects = true
      this.$store.dispatch('projects/fetchProjects', {
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
        returnOnly: true,
        organizationId: this.user.defaultOrganizationId,
      })
        .then(res => { this.projects = [...this.projects, ...res.data.result]; this.hasMore = res.data.result.length >= this.pageSize })
        .catch(error => { this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while fetching projects.') })
        .finally(() => { this.fetchingProjects = true })
    },

  },
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/variables/variables';
  .option{
    margin-bottom:5px;
  }
  .option-name{
    line-height:1;
    margin-left:5px;
    cursor:default;
  }
  .option-default-text{
    margin-left:7px;
  }
</style>
